import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import { Get, Post, Put } from 'utils/axios'
import { getProfile } from 'actions/profile' 
import { handleErrorMsg, getSelectedLanguageContent } from "utils"
import { requestError, requestSuccess } from 'utils/requestHandler'
import { addLoadingContent, removeLoadingContent } from 'reducers/LoadingOverlay'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      banks: [],
      uploadedICFront:[],
      ICFrontImageInfo: {},
      uploadedICBack: [],
      ICBackImageInfo: {},
      uploadedBankStatement: [],
      BankStatementImageInfo: {},
      documentOption: [
        { label: getSelectedLanguageContent("{{IC}}"), value: 'ic' },
        { label: getSelectedLanguageContent("{{PASSPORT}}"), value: 'passport' },
        { label: getSelectedLanguageContent("{{BUSINESS_REGISTRATION_NO}}"), value: 'ssm' }
      ],
      accountOwnershipOptions: [
        { name:  getSelectedLanguageContent("{{SELF}}"),  value: 'self' },
        { name: getSelectedLanguageContent("{{OTHERS}}"),  value: 'others' }
      ],
      genderOptions: [
        { value: 'male', name: getSelectedLanguageContent("{{MALE}}")},
        { value: 'female', name: getSelectedLanguageContent("{{FEMALE}}")},
        { value: "unspecified", name: getSelectedLanguageContent("{{UNSPECIFIED}}")}
      ],
      selectedDocumentType: 'ic',
      uploadedSSMCert:[],
      SSMCertImageInfo: {},
      uploadedSSMCertWithIC: [],
      SSMWithICImageInfo: {},
      showFormFeedbackICFront: false,
      showFormFeedbackICBack: false,
      showFormFeedbackBankStatement: false,
      showFormFeedbackSSMCert: false,
      showAccountOwnerShipOthers: false,
      showAccountOwnerShipMessage: false
    }

    load = param => {
      if( param ){
        this.props.addLoadingContent()
      } else {
        this.props.removeLoadingContent()
      }
    }

    onChangeClientUsersHOC = ( key, val ) => this.setState({ [ key ]: val })

    getBanks = () => Get(
      '/banks',
      this.getBanksSuccess,
      this.getBanksError,
      this.load
    )
    getBanksSuccess = payload => this.setState({
      banks: payload.map( item => ({
        id: item.id, 
        label: item.name, 
        value: item.name
      }) )
    })
    getBanksError = error => requestError( handleErrorMsg( error ) )

    updateClientUser = ( id, data ) => Post(
      `/client_users/${ id }/kyc-customer`,
      data,
      this.updateClientUserSuccess,
      this.updateClientUserError,
      this.load
    )
    updateClientUserSuccess = () => {
      requestSuccess( getSelectedLanguageContent("{{SUBMIT_SUCCESS}}") )
      this.props.getProfile( this.props.data.ClientReducer )
      this.props.updateShowStatusModal( true )
      this.props.updateShowKYC( false )
    }
    updateClientUserError = error => {
      requestError( 
        error.error
          ? _.findIndex( error.error , { type: "unique violation", path: "ic_number" } ) > -1
            ? getSelectedLanguageContent("{{IC_REGISTERED_BEFORE}}")
            : handleErrorMsg( error )
          : handleErrorMsg( error )
      )
    }

    getAddresses = () => Get(
      `/client_users/${ this.props.profile.id }/addresses`,
      this.getAddressesSuccess,
      this.getAddressesError,
      this.load
    )
    getAddressesSuccess = payload => {
      const sortedPayload = _.sortBy(payload, 'id')
      const residentialAddress = _.find(sortedPayload, { is_residential_address: true })

      this.setState({
        addresses: sortedPayload,
        residentialAddress: !_.isEmpty(residentialAddress)
          ? residentialAddress
          : sortedPayload[0]
      });
    }
    getAddressesError = error => requestError( handleErrorMsg( error ))

    render = () => {
      return (
        <WrappedComponent
          { ...this.props }
          { ...this.state }
          onChangeClientUsersHOC={ this.onChangeClientUsersHOC }
          getBanks={ this.getBanks }
          updateClientUser={ this.updateClientUser }
          getAddresses={ this.getAddresses }
          updateAddresses={ this.updateAddresses }
        />
      )
    }
  }
  const mapStateToProps = state => ({ 
    data: state,
    colors: state.ClientReducer.clientInfo.styles?.colors,
    profile: state.ProfileReducer.profile,
    siteInfo: state.ClientReducer.siteInfo,
    clientInfo: state.ClientReducer.clientInfo,
    loadingContent: state.LoadingOverlayReducer.loadingContent
  })
  return connect( mapStateToProps, {
    getProfile, addLoadingContent, removeLoadingContent
  })( WithHOC )
}

export default HOC
